import { useEffect, useState } from "react";
import { DBRequest } from "./dbRequest";

const useRequest = ({ path, method = "get", data = {}, debug, enabled = true }) => {
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      return;
    }
    reloadApiData();
  }, [path, enabled]);

  function reloadApiData() {
    if (!enabled) return;

    DBRequest({
      path,
      method,
      data,
      onResponse: handleResponse,
      onLoading: setIsLoading,
      onError: (error, status) => setServerError({ error, status }),
    });
  }

  function handleResponse(res) {
    if (debug) console.log(res);
    setApiData(res);
  }

  return {
    apiData,
    setApiData,
    isLoading,
    setIsLoading,
    serverError,
    reloadApiData,
  };
};

export default useRequest;
